import _ from 'lodash';
import { useWeatherConditionsData } from 'hooks/useWeatherConditionsData';
import { getEnvironmentSettings } from 'services/environment';

const environmentSettings = getEnvironmentSettings();

export function useWeatherConditions({ conditionsToUse, campaignId }) {
    const { getWeatherConditionOptions, loading, error } = useWeatherConditionsData(campaignId);

    const conditionOptions = getWeatherConditionOptions
        ? getWeatherConditionOptions(conditionsToUse)
        : [];

    return {
        conditionOptions,
        loading,
        error,
    };
}

export function getWeatherConditionQualifier(conditionOptions, type) {
    return _.find(conditionOptions, { value: type })?.qualifierOptions;
}

export function getWeatherConditionTimeframe(conditionOptions, type) {
    const timeFrames = _.find(conditionOptions, { value: type })?.timeframeOptions;
    return timeFrames;
}

export function getWeatherConditionValue(conditionOptions, type) {
    const values = _.find(conditionOptions, { value: type })?.valueOptions;
    if ((type === 'airquality' || type === 'flu') && environmentSettings.env !== 'spain') {
        const newValues = _.filter(values, value => value.alias !== 'veryHigh');
        return newValues;
    }
    return values;
}
